export const TV = 'TV';
export const INTERNET = 'INTERNET';
export const FLEX = 'FLEX';
export const ADVANCED_MODEM = 'ADVANCED_MODEM';
